import { Controller } from "@hotwired/stimulus"
import Flatpickr from "stimulus-flatpickr"
import weekSelectPlugin from "flatpickr/dist/plugins/weekSelect/weekSelect"

export default class extends Flatpickr {
  static targets = ["hiddenInput"]

  initialize() {
    this.config = {
      inline: true,
      plugins: [weekSelectPlugin({})],
      onChange: this.onChange.bind(this)
    }
  }

  connect() {
    super.connect()
  }

  onChange(selectedDates, dateStr, instance) {
    if (this.hasHiddenInputTarget) {
      this.hiddenInputTarget.value = dateStr
      this.element.requestSubmit()
    }
  }

  disconnect() {
    super.disconnect()
  }
}
